/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use VisitorManagementFields from application-types instead.
 */
export enum VisitorManagementFields {
  ALL_FIELDS_REQUIRED = 'ALL_FIELDS_REQUIRED',
  NAME_REQUIRED = 'NAME_REQUIRED',
  NAME_EMAIL_CELL_REQUIRED = 'NAME_EMAIL_CELL_REQUIRED',
  NAME_EMAIL_COMPANY_REQUIRED = 'NAME_EMAIL_COMPANY_REQUIRED',
  NAME_EMAIL_REQUIRED = 'NAME_EMAIL_REQUIRED',
  NAME_CELL_REQUIRED = 'NAME_CELL_REQUIRED',
  NAME_CELL_COMPANY_REQUIRED = 'NAME_CELL_COMPANY_REQUIRED',
  NAME_COMPANY_REQUIRED = 'NAME_COMPANY_REQUIRED',
}
